import { createFileRoute } from '@tanstack/react-router';

import { DuplicatesPage } from '@/features/employers';

export const Route = createFileRoute('/_app/employers/duplicates')({
  staticData: { crumb: 'nav.duplicates' },
  component: DuplicatesPage,
});
